import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-replace-device',
  templateUrl: './replace-device.component.html',
  styleUrls: ['./replace-device.component.scss']
})
export class ReplaceDeviceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
